import { CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { Facets } from '~/services/instantsearch/constants';

export type GTMFilterData = {
    filter_type: string;
    filter_applied: string;
    filter_combination?: string;
};

const getFilterType = (value: string) => {
    let rawValue = value;

    if (value === 'cust_priceRanges' || value === 'cust_effectivePrice') {
        rawValue = 'cust_price';
    }

    if (value === Facets.STORE || value === Facets.STORE_WEB) {
        rawValue = 'cust_withstock';
    }

    if (value === Facets.MEMBERS_OFFER || value === Facets.OFFERS) {
        rawValue = 'cust_offer';
    }

    if (value === 'primary_category_id') {
        rawValue = 'category';
    }

    const normalized = rawValue.replace(/^(cust_spec_|spec_|cust_)/, '');

    // Special case: cust_onOffer.isOnOffer -> isOnOffer
    // cust_onOffer.isMemberOffer -> isMemberOffer
    if (normalized.startsWith('onOffer.')) {
        return normalized.split('.').pop() ?? normalized;
    }

    // Default: cust_categories.name -> categories
    //cust_series -> series
    //cust_spec_allergyFriendly -> allergyFriendly
    return normalized.split('.')[0];
};

export const transformFilterCombination = (
    attribute: string,
    currentRefinements: CurrentRefinementsConnectorParamsItem[],
) => {
    const filterTypes = [
        ...new Set(
            [...currentRefinements.map((item) => item.attribute), attribute].map(getFilterType),
        ),
    ];

    return {
        filterCombination: filterTypes.length > 1 ? filterTypes.join('|') : undefined,
        filterType: getFilterType(attribute),
    };
};

const formatFilterApplied = (filterType: string, filterApplied: string) => {
    if (filterType !== 'price') return filterApplied;

    return filterApplied.replace(/\s*[-,]\s*/, ' - ');
};

export const getGTMFilterData = (raw: GTMFilterData): Partial<GTMFilterData> => {
    const data: Partial<GTMFilterData> = {};

    if (raw.filter_type) data.filter_type = raw.filter_type;

    if (raw.filter_applied)
        data.filter_applied = formatFilterApplied(raw.filter_type, raw.filter_applied);

    if (raw.filter_combination) data.filter_combination = raw.filter_combination;
    return data;
};
